// extracted by mini-css-extract-plugin
export default {"changeList":"changeList__FrUZPY"};